import React from 'react';
import SectionLabel from './SectionLabel';
import Reveal from './Reveal';
import { testimonialLogos } from '../mock';
import { Quote, ShieldCheck } from 'lucide-react';
import { useI18n } from '../i18n/I18nContext';

export default function Testimonials() {
  const { t } = useI18n();
  const items = (t('testimonials.items') || []).map((it, i) => ({ ...it, logo: testimonialLogos[i] }));
  return (
    <section id="referenciak" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5">
        <div className="mb-12 space-y-5 max-w-3xl">
          <SectionLabel>{t('testimonials.tag')}</SectionLabel>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-semibold text-slate-900 leading-[1.05]">
            {t('testimonials.title_a')} <br className="hidden md:block" />
            <span className="text-gradient-green">{t('testimonials.title_b')}</span>
          </h2>
          <p className="text-slate-700/60 text-sm tracking-widest">{t('testimonials.subtitle')}</p>
        </div>
        <div className="relative mb-14 overflow-hidden rounded-2xl border border-blue-500/10 bg-white py-8">
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />
          <div className="flex gap-16 animate-marquee whitespace-nowrap">
            {[...items, ...items, ...items].map((t2, i) => (
              <div key={i} className="flex items-center h-14 shrink-0">
                <img src={t2.logo} alt={t2.company} className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" style={{ filter: 'brightness(0)' }} />
              </div>
            ))}
          </div>
        </div>
        <div className="grid gap-4 lg:grid-cols-3">
          {items.map((it, i) => (
            <Reveal key={it.company} delay={i * 80}>
              <div className="relative h-full rounded-3xl border border-blue-500/10 bg-white p-7 overflow-hidden group hover:border-blue-500/30 card-lift">
                <Quote className="absolute -top-2 -right-2 h-24 w-24 text-blue-500/[0.06] rotate-180" strokeWidth={1} />
                <div className="relative flex items-center justify-between mb-6">
                  <img src={it.logo} alt={it.company} className="h-10 w-auto object-contain" style={{ filter: 'brightness(0)' }} />
                  <div className="flex items-center gap-1 text-[10px] tracking-widest text-blue-600">
                    <ShieldCheck className="h-3.5 w-3.5" />{t('common.verified')}
                  </div>
                </div>
                <p className="relative text-sm text-slate-700 leading-relaxed mb-6">“{it.quote}”</p>
                <div className="relative pt-4 border-t border-blue-500/10">
                  <div className="font-display text-sm font-medium text-slate-900">{it.company}</div>
                  <div className="text-xs text-blue-600">{it.role}</div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
